const toEllipsisMiddle = require('../../../utils/toEllipsisMiddle');

const adminCtor = require('./utils/adminCtor');
const merchantCtor = require('./utils/merchantCtor');
const {displayDateAdmin, displayDateTimeAdmin, displayDateDetailedAdmin, displayDateMerchant, displayDateTimeMerchant, displayDateDetailedMerchant} = require('./utils/displayDateTime');
const {displayAmountAdmin, displayAmountMerchant} = require('./utils/displayAmountData');

const {DisplayAmountFCAdmin, DisplayAmountFCMerchant} = require('./components/DisplayAmountFC');

const ellipsisMiddleFn = (val) => toEllipsisMiddle(val, 16);

const displayDataAdminDefault = adminCtor();
const displayDataAdminEllipsed = adminCtor({dataHandler: ellipsisMiddleFn});

const displayDataMerchantDefault = merchantCtor();
const displayDataMerchantEllipsed = merchantCtor({dataHandler: ellipsisMiddleFn});

module.exports = {
  DisplayDataAdmin: displayDataAdminDefault,
  DisplayIdAdmin: displayDataAdminEllipsed,
  DisplayAddressAdmin: displayDataAdminEllipsed,
  DisplayHashAdmin: displayDataAdminEllipsed,
  DisplayDateAdmin: displayDateAdmin,
  DisplayDateTimeAdmin: displayDateTimeAdmin,
  DisplayDateDetailedAdmin: displayDateDetailedAdmin,
  DisplayAmountAdmin: displayAmountAdmin,
  DisplayAmountFCAdmin,

  DisplayDataMerchant: displayDataMerchantDefault,
  DisplayIdMerchant: displayDataMerchantEllipsed,
  DisplayAddressMerchant: displayDataMerchantEllipsed,
  DisplayHashMerchant: displayDataMerchantEllipsed,
  DisplayDateMerchant: displayDateMerchant,
  DisplayDateTimeMerchant: displayDateTimeMerchant,
  DisplayDateDetailedMerchant: displayDateDetailedMerchant,
  DisplayAmountMerchant: displayAmountMerchant,
  DisplayAmountFCMerchant,
}
